module.exports = __webpack_public_path__ + "img/143.9.3f88c0b3.png";